import { render } from "./ArgumentCount.vue?vue&type=template&id=245f0ccd&scoped=true&ts=true"
import script from "./ArgumentCount.vue?vue&type=script&lang=ts"
export * from "./ArgumentCount.vue?vue&type=script&lang=ts"

import "./ArgumentCount.vue?vue&type=style&index=0&id=245f0ccd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245f0ccd"]])

export default __exports__